export type AdminRole = "superadmin" | "platform_admin" | "platform_superadmin" | "platform_ops" | "sachbearbeitung" | "lesend";
export type PermissionKey =
  | "dashboard"
  | "resolutions"
  | "qr_scan"
  | "resolutions_create"
  | "resolutions_update"
  | "resolutions_delete"
  | "resolutions_delete_completed"
  | "objects"
  | "objects_create"
  | "objects_update"
  | "objects_delete"
  | "units"
  | "units_create"
  | "units_update"
  | "units_delete"
  | "units_view_technical"
  | "owners"
  | "owners_create"
  | "owners_update"
  | "owners_delete"
  | "assignments"
  | "assignments_create"
  | "assignments_update"
  | "assignments_delete"
  | "imports"
  | "imports_create"
  | "imports_update"
  | "imports_delete"
  | "templates"
  | "templates_create"
  | "templates_update"
  | "templates_delete"
  | "settings"
  | "settings_create"
  | "settings_update"
  | "settings_delete"
  | "admin_users"
  | "admin_users_create"
  | "admin_users_update"
  | "admin_users_delete"
  | "platform_tenants"
  | "platform_tenants_create"
  | "platform_tenants_update"
  | "platform_tenants_delete"
  | "platform_services_notify"
  | "audit"
  | "debug";
export type UserPermissions = Record<PermissionKey, boolean>;

export type AuthUser = {
  id: string;
  username: string;
  displayName: string;
  avatarUrl?: string;
  role: AdminRole;
  permissionGroupName?: string;
  permissions: UserPermissions;
  objectScope?: {
    mode: "all" | "include";
    objectIds: string[];
  };
  status: "aktiv" | "inaktiv";
  lastLoginAt?: string;
};

const TOKEN_KEY = "admin_auth_token";

export const getAuthToken = () => {
  if (typeof window === "undefined") return "";
  return localStorage.getItem(TOKEN_KEY) ?? "";
};

export const setAuthToken = (token: string) => {
  if (typeof window === "undefined") return;
  if (!token) {
    localStorage.removeItem(TOKEN_KEY);
    return;
  }
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearAuthToken = () => {
  if (typeof window === "undefined") return;
  localStorage.removeItem(TOKEN_KEY);
};
